import { render, staticRenderFns } from "./resource-info.vue?vue&type=template&id=b421f666&"
import script from "./resource-info.vue?vue&type=script&lang=js&"
export * from "./resource-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "resource-info.vue"
export default component.exports